import { IValue } from "./ivalue";
import { ControlType } from "../controltype";
import { EventEmitter } from "@angular/core";

export class NumberRangeValue implements IValue {

    startValue: number;
    endValue: number;

    clear$ = new EventEmitter();

    constructor(data: { startValue: string, endValue: string } = { startValue: '', endValue: '' }) {
        this.startValue = data.startValue ? parseFloat(data.startValue) : null;
        this.endValue = data.endValue ? parseFloat(data.endValue) : null;
    }


    isEmpty(): boolean {
        return (this.startValue == null && this.endValue == null);
    }

    getControlType(): ControlType {
        return ControlType.NumberRange;
    }

    clearValue(): void {
        this.startValue = undefined;
        this.endValue = undefined;
        this.clear$.emit();
    }
    setOriginalValue(value: any): void {
        throw new Error("Method not implemented.");
    }
    getOriginalValue() {
        return {
            begin: this.startValue,
            end: this.endValue
        };
    }

}

export class NumberRangeValueConvertor {
    convertToObject(obj: IValue): Object {
        let dropDownListValue = obj as NumberRangeValue;
        let jobj = new Object();
        jobj["startValue"] = dropDownListValue.startValue;
        jobj["endValue"] = dropDownListValue.endValue;
        return jobj;
    }

    initFromObject(jobj: Object): NumberRangeValue {
        let numberRangeValue = new NumberRangeValue();
        if (!!(jobj["startValue"])) {
            numberRangeValue.startValue = jobj["startValue"] as number;
        }
        if (!!(jobj["endValue"])) {
            numberRangeValue.endValue = jobj["endValue"] as number;
        }
        return numberRangeValue;
    }
}